import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import QuotationForm from './QuotationForm';
import QuotationUploadOffcanvas from '../sales/deal/QuotationUploadOffcanvas';
import { useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import PurchaseOrderForm from '../purchaseorder/PurchaseOrderForm';
import ProformaInvoiceModal from '../ProformaInvoice/ProformaInvoiceModal';
import { useAuth } from '../../context/AuthContext';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';
import QuotationDetailsModal from './QuotationDetailsModal';
import { displayConvertedAmount } from '../../utils/currencyConverter';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import ContactModal from './../contact/ContactModal';
import Dropdown from "react-bootstrap/Dropdown";

import { Button, Form, Row, Col, Modal, Offcanvas, Table } from 'react-bootstrap';

const QuotationList = ({ projectId, clientId, projectName, clientName, clientCurrency, projectData, setProjectDetails }) => {
    const [quotations, setQuotations] = useState([]);
    const [projects, setProjects] = useState([]);
    const [refNo, setRefNo] = useState('');
    const [products, setProducts] = useState([]);
    const [showUploadedQuotationEdit, setShowUploadedQuotationEdit] = useState(false);
    const [selectedUploadedQuotation, setSelectedUploadedQuotation] = useState(null);

    const [showVendorsModal, setShowVendorsModal] = useState(false);
    const [selectedVendorId, setSelectedVendorId] = useState(null);
    const [proformainvoices, setPerformaInvoices] = useState("");
    const [showInvoiceDetails, setShowInvoiceDetails] = useState(null);
    const [showVendorDetails, setShowVendorDetails] = useState(false);
    const [selectedQuotationProducts, setSelectedQuotationProducts] = useState([]);
    const [showPurchaseOrderModal, setShowPurchaseOrderModal] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedQuotationId, setSelectedQuotationId] = useState(null);
    const [selectedQuotationData, setSelectedQuotationData] = useState(null);
    const [errors, setErrors] = useState({});
    const [showStatusModal, setStatusModal] = useState(false);
    const [selectedProformaInvoiceId, setSelectedProformaInvoiceId] = useState(null);
    const [selectedPurchaseOrderId, setSelectedPurchaseOrderId] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        position: '',
        contact_type: '',
        external_type: ''
    });
    const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState([]);
    const [purchaseorder, setPurchaseOrders] = useState([]);
    const [poId, setPoId] = useState(null);
    const didFetchRef = useRef(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [showContactModal, setShowContactModal] = useState(false);
    const [isQuoModalHidden, setIsQuoModalHidden] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [vendorNames, setVendorNames] = useState({});
    const WithCreatePermission = withPermission(({ children }) => children, ['quotation-create']);
    const WithEditPermission = withPermission(({ children }) => children, ['quotation-Edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['quotation-delete']);
    const WithviewPermission = withPermission(({ children }) => children, ['quotation-view']);
    const WithPICPermission = withPermission(({ children }) => children, ['proformainvoice-create']);
    const WithPILPermission = withPermission(({ children }) => children, ['proformainvoice-list']);
    const WithPIDPermission = withPermission(({ children }) => children, ['proformainvoice-delete']);

    const WithPOCPermission = withPermission(({ children }) => children, ['purchaseorder-create']);
    const WithPOLPermission = withPermission(({ children }) => children, ['purchaseorder-list']);
    const WithPODPermission = withPermission(({ children }) => children, ['purchaseorder-delete']);
    const WithPOEPermission = withPermission(({ children }) => children, ['purchaseorder-edit']);

    const [isEdit, setIsEdit] = useState(false);


    const { id } = useParams();
    const [statusList, setStatusList] = useState([
        'open',
        'Quotation_Approved',
        'PO_received',
        'work_completed',
        'payment_confirmed',
        'payment_collected',
    ]);
    const [selectedStatus, setSelectedStatus] = useState('open');
    const [description, setDescription] = useState('');
    const [file, setFile] = useState(null);


    useEffect(() => {
        if (clientId) {  // Make sure clientId exists
            fetchQuotations(currentPage);
        } else {
            console.log('No clientId available');
        }
    }, [currentPage, clientId]);

    useEffect(() => {
        console.log('showPurchaseOrderModal state changed:', showPurchaseOrderModal);
    }, [showPurchaseOrderModal]);
    useEffect(() => {
        if (showStatusModal) {
            fetchContacts();
        }
    }, [showStatusModal]);

    const fetchProjects = async (page = 1, perPage = 100, all = false) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            // Build the URL with query parameters
            let url = `${backendUrl}/api/projects?all=true`;

            // If all is true, add the all=true parameter to the URL
            // if (all) {
            //     url += `&all=true`;
            // }

            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });

            const projectData = response.data.Data || [];
            setProjects(projectData);

            const totalPages = response.data.Data?.meta?.total_pages || 1;
            setPageCount(totalPages);
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };


    // const fetchProducts = async () => {
    //     try {
    //         const backendUrl = process.env.REACT_APP_BACKEND_URL;
    //         const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //         const token = userInfo?.token;

    //         let allProducts = [];



    //         const response = await axios.get(`${backendUrl}/api/products`, {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //             },
    //         });

    //         const data = response.data.Data;

    //         allProducts = [...allProducts, ...data]; // Append new products to the list


    //         setProducts(data);
    //     } catch (error) {
    //         console.error('Error fetching products:', error);
    //     }
    // };

    const fetchContacts = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const contactType = 'internal'; // You can change this to a variable if needed

            const response = await axios.get(`${backendUrl}/api/contact`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,
                params: { contact_type: contactType } // Pass contact_type as a query parameter
            });

            const filteredContacts = response.data.Data.filter(contact => {
                return !selectedContacts.some(selected => selected.id === contact.id);
            });

            setContacts(filteredContacts || []);

        } catch (error) {
            console.error('Error fetching contacts:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: "Failed to fetch contacts. Please try again.",
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    // Adjust the container's position if needed
                    const container = Swal.getContainer();
                    container.style.top = '50px'; // Change this value as desired
                }
            });
        }
    };

    const fetchQuotations = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const url = `${backendUrl}/api/quotations?project_id=${projectId}&client_id=${clientId}&page=${page}`;
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,

            });

            const quotationData = response.data.quotations || [];
            setQuotations(quotationData);

            // Update vendor names and vendors
            // const vendorNamesObj = {};
            // const vendorsObj = {};

            // quotationData.forEach(quotation => {
            //     quotation.product_item_details.forEach(product => {
            //         const vendor = product.product?.vendor;
            //         if (vendor && !vendorNamesObj[vendor.id]) {
            //             vendorNamesObj[vendor.id] = vendor.name;
            //             vendorsObj[vendor.id] = vendor.currency;
            //         }
            //     });
            // });

            // setVendorNames(vendorNamesObj);
            // setVendors(vendorsObj);
            // In fetchQuotations function in QuotationList.jsx:
            const vendorNamesObj = {}; // Keep for vendorNames mapping
            const vendorsArray = [];
            const vendorsObj = {};   // Create array for vendor objects

            quotationData.forEach(quotation => {
                quotation.product_item_details.forEach(product => {
                    const vendor = product.product?.vendor;
                    if (vendor && !vendorNamesObj[vendor.id]) {
                        vendorNamesObj[vendor.id] = vendor.name;
                        vendorsObj[vendor.id] = vendor.currency;

                        // Add vendor object to array
                        vendorsArray.push({
                            id: vendor.id,
                            name: vendor.name,
                            currency: vendor.currency,
                            business_name: vendor.business_name,
                            // Add any other vendor properties you need
                        });
                    }
                });
            });

            setVendorNames(vendorNamesObj);
            setVendors(vendorsArray); // Set as array

            const totalPages = response.data.meta?.total_pages || 1;
            setPageCount(totalPages);

            setCurrentPage(page);
        } catch (error) {
            console.error('Error fetching quotations:', error);
        }
    };


    const addQuotation = async (newQuotation) => {
        try {
            if (!newQuotation.quotation_status) {
                newQuotation.quotation_status = 'open';
            }
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const isSalesQuotation = searchParams.get('sales') === 'true';

            // Add the `sales` field based on URL parameter
            if (isSalesQuotation) {
                newQuotation.issales = true;
            }
            const response = await axios.post(`${backendUrl}/api/quotations`, newQuotation, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,

                },
            });

            const createdQuotation = response.data.quotation;

            // Instead of refetching all quotations, add the new one to the local state
            setQuotations((prevQuotations) => [...prevQuotations, createdQuotation]);

            handleCloseModal(); // Close modal after saving
        } catch (error) {


            console.error(`Error adding quotation`, error);


        }
    };



    const editQuotation = async (quotationId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/quotations/${quotationId}?_method=PUT`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,


                },
            });

            const updatedQuotation = response.data.quotation;

            if (updatedQuotation) {

                setQuotations((prevQuotations) =>
                    prevQuotations.map((quotation) =>
                        quotation.id === updatedQuotation.id ? updatedQuotation : quotation
                    )
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {

            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error('Error updating quotation:', error);
            }
        }
    };

    const deleteQuotation = async (projectId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;

                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');

                    const token = userInfo?.token;

                    await axios.delete(` ${backendUrl}/api/quotations/${projectId}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,

                        },
                    });

                    setQuotations(quotations.filter(quotation => quotation.id !== projectId));
                    Swal.fire(
                        "Deleted!",
                        "The quotation has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting quotation:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete quotation. Please try again.",
                        "error"
                    );
                }
            }
        });
    };


    // };
    const handleShowModal = (quotationId = null) => {
        if (quotationId) {
            const quotationToEdit = quotations.find(quotation => quotation.id === quotationId);
            if (quotationToEdit?.is_uploaded) {
                setSelectedUploadedQuotation(quotationToEdit);
                setShowUploadedQuotationEdit(true);
                return;
            }
            setSelectedQuotationData(quotationToEdit || null); // Set data for editing
        } else {
            setSelectedQuotationData(null); // Clear form data for creating new quotation
            setErrors({}); // Clear any errors
            const project = projects.find(p => p.id === projectId); // Fetch the project based on projectId
            // const refNo = generateSerialNo(project); // Generate ref_no for new quotation
            setRefNo(refNo); // Set the generated ref_no in the state
        }
        setSelectedQuotationId(quotationId);
        setShowModal(true);
    };


    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedQuotationId(null);
        setSelectedQuotationData(null);
        setErrors({});
    };

    const handlePageChange = (selectedItem) => {
        const newPage = selectedItem.selected + 1; // ReactPaginate uses 0-based index
        setCurrentPage(newPage); // Update state
        // fetchQuotations(newPage); // Fetch quotations for the new page
    };
    const [showProformaModal, setShowProformaModal] = useState(false);
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const handleVendorDropdownChange = (quotation) => {
        const productsWithVendors = quotation?.product_item_details.filter(product => product.product?.vendor_id);
        if (productsWithVendors.length > 0) {
            // Extract vendor names and details
            const vendorNamesObj = {};
            const vendorsObj = {};

            productsWithVendors.forEach(product => {
                const vendor = product.product?.vendor;
                if (vendor && !vendorNamesObj[vendor.id]) {
                    vendorNamesObj[vendor.id] = vendor.name;
                    vendorsObj[vendor.id] = vendor.currency;
                }
            });

            // Update states
            setSelectedQuotationProducts(productsWithVendors);
            setVendorNames(vendorNamesObj);
            setVendors(vendorsObj);
            setSelectedQuotationId(quotation.id);
            setShowVendorsModal(true);
        } else {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'No vendors associated with products in this quotation.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    // Modify the container's inline style to move it a bit down
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                }
            });


        }
    };


    const [poGenerated, setPoGenerated] = useState(false);  // Track if PO has been generated

    const handleCreatePurchaseOrder = (vendorId) => {
        console.log('Vendor ID selected:', vendorId); // Debug log
        setSelectedVendorId(vendorId);
        setShowPurchaseOrderModal(true); // Show the Purchase Order modal
        console.log('showPurchaseOrderModal set to:', true); // Debug log
        setShowVendorsModal(false); // Close the vendor modal
        // setQuotations((prevQuotations) =>
        //     prevQuotations.map((quotation) =>
        //         quotation.id === selectedQuotationId
        //             ? { ...quotation, purchase_orders: [...quotation.purchase_orders, newPO] }
        //             : quotation
        //     )
        // );
        setPoId(null);

    };

    const deletePurchaseOrder = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');

                    const token = userInfo?.token;

                    // Delete the purchase order from the backend
                    await axios.delete(`${backendUrl}/api/purchase-order/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,

                        },
                    });

                    // Update the state to remove the deleted purchase order from the quotations
                    setQuotations(prevQuotations =>
                        prevQuotations.map(quotation => ({
                            ...quotation,
                            purchase_order: quotation?.purchase_order?.filter(po => po.id !== id), // Filter out the deleted PO
                        }))
                    );
                    Swal.fire(
                        "Deleted!",
                        "The purchase order has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting purchase order:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete purchase order. Please try again.",
                        "error"
                    );
                }
            }
        });

    };


    const handleClosePurchaseOrderModal = () => {
        setShowPurchaseOrderModal(false); // Close PO modal
        setSelectedVendorId(null); // Reset selected vendor
    };

    const handleCloseVendorsModal = () => {
        setShowVendorsModal(false);
    };

    const getNextStatus = (currentStatus) => {
        const statusMap = {
            open: 'Quotation Approved',
            'Quotation Approved': 'PO Received',
            // 'PO Received': 'work completed',
            'PO Received': 'Assign to Project Team',
            'Assign to Project Team': 'work completed',
            'work completed': 'payment confirmed',
            'payment confirmed': 'payment collected',
        };

        const nextStatus = statusMap[currentStatus];
        return nextStatus
            ? nextStatus.replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize if exists
            : null;        // return nextStatus.replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const [visibleDropdownIds, setVisibleDropdownIds] = useState(new Set());
    const handleSelectProformaInvoice = (proformaInvoiceId) => {
        console.log("Selected Proforma Invoice ID:", proformaInvoiceId); // Log ID to check if it's correct

        setSelectedProformaInvoiceId(proformaInvoiceId);
        setDropdownVisible((prevState) => (prevState === proformaInvoiceId ? null : proformaInvoiceId));

    };

    const dropdownRefs = useRef({});

    const handleStatusClick = (quotationId) => {
        setDropdownVisible((prevState) => (prevState === quotationId ? null : quotationId));
    };

    const handleOutsideClick = (event) => {
        // Check if the click is outside any dropdown
        if (
            dropdownVisible &&
            dropdownRefs.current[dropdownVisible] &&
            !dropdownRefs.current[dropdownVisible].contains(event.target)
        ) {
            setDropdownVisible(null); // Close the dropdown
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [dropdownVisible]);


    const [teamMembers, setTeamMembers] = useState([]);
    const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);


    const [projectTeam, setProjectTeam] = useState([]);
    const [selectedContacts, setSelectedContacts] = useState([]);

    // const handleDropdownSelect = (quotationId, nextStatus) => {
    //     setSelectedQuotationId(quotationId);
    //     if (nextStatus === "Assign to Project Team") {
    //         // Prepopulate contacts from projectData (no API call)
    //         setSelectedContacts([]);
    //     }
    //     setSelectedStatus(nextStatus);

    //     setDropdownVisible(null); // Close the dropdown
    //     setStatusModal(true); // Open the modal
    // };
    const [currentStatus, setCurrentStatus] = useState("");

    const handleDropdownSelect = (quotationId, nextStatus, currentQuotationStatus) => {
        console.log("Selected Status:", nextStatus);
        setSelectedQuotationId(quotationId);
        setSelectedStatus(nextStatus); // Make sure this is being updated
        setStatusModal(true);
        setDropdownVisible(null);
    };



    const handleStatusUpdate = async () => {


        if (!selectedProformaInvoiceId && !selectedQuotationId && !selectedPurchaseOrderId) {
            console.error("No valid ID selected for update!");
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Please select a valid Proforma Invoice, Quotation, or Purchase Order to update the status.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    // Modify the container's inline style to move it a bit down
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                }
            });
            return; // Exit if no ID is selected
        }

        // Handle Proforma Invoice Status Update
        if (selectedProformaInvoiceId && !selectedQuotationId && !selectedPurchaseOrderId) {
            console.log("Updating Proforma Invoice Status...");
            try {
                const formData = new FormData();
                formData.append('description', description);
                formData.append('file', file);

                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');

                const token = userInfo?.token;

                const invoiceUrl = `${backendUrl}/api/proformainvoice/${selectedProformaInvoiceId}/pistatus`;
                console.log("Calling API for Proforma Invoice Status Update: ", invoiceUrl);

                const response = await axios.post(invoiceUrl, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,

                    },
                });

                console.log("Proforma Invoice Status updated successfully");
                setSelectedProformaInvoiceId(null);
                fetchQuotations();  // Refetch quotations after update
                setDropdownVisible(null);
                resetForm();
                setStatusModal(false);
            } catch (error) {
                handleError(error);  // Handle errors properly
                setStatusModal(false);

            }
        }
        // Handle Quotation Status Update
        else if (selectedQuotationId && !selectedProformaInvoiceId && !selectedPurchaseOrderId) {
            console.log("Updating Quotation Status...");
            try {
                const formData = new FormData();
                formData.append('description', description);
                formData.append('file', file);
                // if (selectedStatus === "Assign To Project Team" && selectedContacts.length > 0) {
                //     const contactIds = selectedContacts.map(contact => contact.value); // Assuming options use {value, label}
                //     formData.append('contact_ids', JSON.stringify(contactIds)); // Send contact IDs as JSON
                // }
                if (selectedStatus === "Assign To Project Team" && selectedContacts.length > 0) {
                    selectedContacts.forEach((contact) => {
                        formData.append("contact_ids[]", contact.value); // Correct way to send multiple values
                    });
                }
                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');

                const token = userInfo?.token;

                const url = `${backendUrl}/api/quotations/${selectedQuotationId}/status`;
                console.log("Calling API for Quotation Status Update: ", url);

                const response = await axios.post(url, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,

                    },
                });
                if (selectedStatus === "Assign To Project Team" && projectId) {
                    console.log("📢 Updating project contacts...");

                    const selectedContactIds = selectedContacts.map(c => c.value);
                    const existingContacts = projectData?.contacts || [];

                    // Create a map of existing contacts for quick lookup
                    const existingContactsMap = new Map(existingContacts.map(c => [c.id, c]));

                    // Merge new contacts, ensuring full contact details are preserved
                    const updatedContacts = [
                        ...existingContacts,
                        ...selectedContacts
                            .filter(c => !existingContactsMap.has(c.value)) // Avoid duplicates
                            .map(c => ({
                                id: c.value,
                                ...c, // Include all available contact data
                            })),
                    ];

                    // Make API call to update contacts
                    const response = await axios.put(`${backendUrl}/api/projects/${projectId}`, {
                        name: projectData.name,
                        contacts: updatedContacts.map(contact => ({ id: contact.id })), // API expects only IDs
                    }, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,

                        },
                    });

                    // ✅ Ensure UI updates with FULL contact details from API response
                    setProjectDetails(prev => ({
                        ...prev,
                        contacts: response.data.Data.contacts, // Store complete contact details
                    }));

                    console.log("✅ Project contacts updated successfully!", response.data.Data.contacts);
                }

                console.log("Quotation Status updated successfully");
                setSelectedQuotationId(null);
                fetchQuotations();  // Refetch quotations after update
                setDropdownVisible(null);
                resetForm();
                setStatusModal(false);
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Quotation status updated successfully!',
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {

                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    }
                });
            } catch (error) {
                handleError(error);  // Handle errors properly
                setStatusModal(false);

            }
        }
        // Handle Purchase Order Status Update
        else if (selectedPurchaseOrderId && !selectedProformaInvoiceId && !selectedQuotationId) {
            console.log("Updating Purchase Order Status...");
            try {
                const formData = new FormData();
                formData.append('description', description);
                formData.append('file', file);

                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');

                const token = userInfo?.token;

                const poUrl = `${backendUrl}/api/purchaseorder/${selectedPurchaseOrderId}/postatus`;
                console.log("Calling API for Purchase Order Status Update: ", poUrl);

                const response = await axios.post(poUrl, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,

                    },
                });

                console.log("Purchase Order Status updated successfully");
                setSelectedPurchaseOrderId(null);
                fetchQuotations();  // Refetch quotations after update
                setDropdownVisible(null);
                resetForm();
                setStatusModal(false);
            } catch (error) {
                handleError(error);  // Handle errors properly
                setStatusModal(false);

            }
        }
    };
    const handleError = (error) => {
        if (error.response?.data?.message) {
            const errorMessage = error.response.data.message;
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: errorMessage,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                    container.style.width = '380px';
                    container.style.fontSize = '11px';
                }
            });
        } else {
            console.error('Error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'An unexpected error occurred. Please try again.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px'; // Change this value as desired
                }
            });
        }
    };

    const resetForm = () => {
        setDescription('');
        setFile(null);
    };
    const contactOptions = contacts.map(contact => ({
        value: contact.id,
        label: contact.name
    }));
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    // const splitOrderByRevenueType = (order) => {
    //     const subscriptionItems = [];
    //     const deploymentItems = [];
    //     let subscriptionTotal = 0;
    //     let deploymentTotal = 0;

    //     order.quotation?.product_item_details?.forEach(item => {
    //         const revenueType = item.product?.revenue_type;
    //         const itemTotal = parseFloat(item.subtotal) || 0;

    //         if (revenueType === 'deferred') {
    //             subscriptionItems.push(item);
    //             subscriptionTotal += itemTotal;
    //         } else if (revenueType === 'immediate') {
    //             deploymentItems.push(item);
    //             deploymentTotal += itemTotal;
    //         }
    //     });

    //     return {
    //         subscription: {
    //             items: subscriptionItems,
    //             total: subscriptionTotal,
    //             count: subscriptionItems.length
    //         },
    //         deployment: {
    //             items: deploymentItems,
    //             total: deploymentTotal,
    //             count: deploymentItems.length
    //         }
    //     };
    // };

    // Split order by revenue type
    const splitOrderByRevenueType = (order) => {
        const subscriptionItems = [];
        const deploymentItems = [];
        let subscriptionTotal = 0;
        let deploymentTotal = 0;

        const subscriptionPeriod = order.quotation?.subscription_period || 1; // Default 1 month

        order.quotation?.product_item_details?.forEach(item => {
            const revenueType = item.product?.revenue_type;
            const itemTotal = parseFloat(item.subtotal) || 0;

            if (revenueType === 'deferred') {
                subscriptionItems.push({
                    ...item,
                    amountPerMonth: itemTotal,
                    totalAmount: itemTotal * subscriptionPeriod
                });
                subscriptionTotal += itemTotal * subscriptionPeriod;
            } else if (revenueType === 'immediate') {
                deploymentItems.push(item);
                deploymentTotal += itemTotal;
            }
        });

        return {
            subscription: {
                items: subscriptionItems,
                total: subscriptionTotal,       // total for all months
                perMonthTotal: subscriptionTotal / (subscriptionPeriod || 1), // optional
                count: subscriptionItems.length
            },
            deployment: {
                items: deploymentItems,
                total: deploymentTotal,
                count: deploymentItems.length
            }
        };
    };


    const handleGenerateProformaInvoice = (quotation) => {
        // 1️⃣ Split the items by revenue type
        const revenueSplit = splitOrderByRevenueType({ quotation });

        // 2️⃣ Add this split info to selectedQuotationData (for modal)
        setSelectedQuotationData({
            ...quotation,
            revenueSplit,
        });

        // 3️⃣ Show the modal
        setShowProformaModal(true);

        // 4️⃣ (Optional) Update quotation list in state if you need it
        setQuotations(prevQuotations =>
            prevQuotations.map(q =>
                q.id === quotation.id
                    ? { ...q, proforma_invoices: [...(q.proforma_invoices || []), {}] }
                    : q
            )
        );
    };


    // const handleGenerateProformaInvoice = (quotation) => {
    //     setSelectedQuotationData(quotation);
    //     setShowProformaModal(true); 
    //     setQuotations(prevQuotations =>
    //         prevQuotations.map(q =>
    //             q.id === quotation.id
    //                 ? { ...q, proforma_invoices: [...(q.proforma_invoices || []), { /* new invoice details */ }] }
    //                 : q
    //         )
    //     );
    // };
    // const [proformainvoices, setPerformaInvoices] = useState([]);

    // const handleCreateProformaInvoice = (newInvoice) => {
    //     setQuotations(prevQuotations =>
    //         prevQuotations.map(q =>
    //             q.id === newInvoice.quotation_id
    //                 ? { ...q, proforma_invoices: [...q.proforma_invoices, newInvoice] }
    //                 : q
    //         )
    //     );
    // };


    const showTaxDetails = (proformainvoice) => {
        if (proformainvoice?.tax_invoice_generated) {
            const taxDetails = proformainvoice?.tax_invoice;
            console.log('quo:', proformainvoice);
            console.log('tax:', taxDetails);

            navigate(`/proformainvoice/tax-details/${proformainvoice.id}`, {
                state: { taxDetails, proformainvoice }, // Passing tax data as state
            });
        } else {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'No tax generated for this invoice',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    // Adjust the container's position if needed
                    const container = Swal.getContainer();
                    container.style.top = '50px'; // Change this value as desired
                }
            });
        }
    };
    const handleCreateProformaInvoice = (newInvoice) => {
        setQuotations(prevQuotations => {
            const updatedQuotations = prevQuotations.map(q =>
                q.id === newInvoice.quotation_id
                    ? { ...q, proforma_invoices: [...q.proforma_invoices, newInvoice] }
                    : q
            );
            console.log('Updated Quotations:', updatedQuotations); // Debugging
            return updatedQuotations;
        });
    };


    const handleCloseProformaModal = () => {
        setShowProformaModal(false); // Close the modal
        setSelectedQuotationData(null); // Clear selected data

    };
    const deletePerformaInvoice = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');

                    const token = userInfo?.token;

                    await axios.delete(`${backendUrl}/api/proformainvoice/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,

                        },
                    });

                    setQuotations(prevQuotations =>
                        prevQuotations.map(quotation => ({
                            ...quotation,
                            proforma_invoices: quotation.proforma_invoices.filter(invoice => invoice.id !== id),
                        }))
                    );

                    setPerformaInvoices(prevInvoices => {
                        if (Array.isArray(prevInvoices)) {
                            return prevInvoices.filter(invoice => invoice.id !== id);
                        } else {
                            console.error('Expected an array for prevInvoices but received:', prevInvoices);
                            return [];
                        }
                    });
                    Swal.fire(
                        "Deleted!",
                        "The proforma invoice has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting proforma invoice:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete proforma invoice. Please try again.",
                        "error"
                    );
                }
            }
        });

    };


    // Add these to your component
    const [activeActionDropdown, setActiveActionDropdown] = useState(null);
    const actionDropdownRefs = useRef({});

    const toggleActionsDropdown = (id) => {
        setActiveActionDropdown(activeActionDropdown === id ? null : id);
    };

    const getDropdownPosition = (id) => {
        const element = actionDropdownRefs.current[id];
        if (!element) return { top: 0, left: 0 };

        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

        // Position above the icon (for drop='up')
        return {
            top: rect.top + scrollTop - 10, // Position above
            left: rect.left + scrollLeft,
        };
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (activeActionDropdown &&
                !actionDropdownRefs.current[activeActionDropdown]?.contains(event.target)) {
                setActiveActionDropdown(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [activeActionDropdown]);
    const handleToggleInvoiceDetails = () => {
        setShowInvoiceDetails(!showInvoiceDetails);
        setShowVendorDetails(!showVendorDetails);


    };
    const handleEditClick = (quotation, purchaseOrderId) => {
        // Find the specific purchase order by its ID
        const selectedPO = quotation.purchase_order.find(po => po.id === purchaseOrderId);

        if (!selectedPO) {
            console.error("Purchase Order not found");
            return; // Exit if the purchase order is not found
        }

        // Create the updated purchase order data
        const updatedPurchaseOrder = {
            ...selectedPO, // Include the specific purchase order details
            product_item_details: selectedPO.product_item_details || [], // Ensure product details are included
        };

        // Set the selected purchase order for editing
        setSelectedPurchaseOrder(updatedPurchaseOrder);
        setPoId(purchaseOrderId); // Set the ID of the purchase order
        setShowPurchaseOrderModal(true); // Show the modal for editing

        console.log("Updated Purchase Order:", updatedPurchaseOrder);
    };

    const handleShowDetailsModal = (quotationId) => {
        setSelectedQuotationId(quotationId);
        setShowDetailsModal(true);
    };

    const handleCloseDetailsModal = () => {
        setShowDetailsModal(false);
        setSelectedQuotationId(null);
    };

    const handleContactModalClose = (newContact) => {
        setShowContactModal(false);

        if (newContact) {
            // Add the new contact to the contacts list
            setContacts((prev) => [newContact, ...prev]);

            // Update selectedContacts with the newly created contact
            setSelectedContacts([{ label: newContact.name, value: newContact.id }]);
        }

        // Reopen the Status Modal after contact creation
        setIsQuoModalHidden(false);
        setStatusModal(true);
    };

    useEffect(() => {
        if (!showContactModal) {
            setErrors({});
        }
    }, [showContactModal]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        if (!formData.phone) newErrors.phone = 'Phone is required';



        return newErrors;
    };
    const [loading, setLoading] = useState(false);



    const handleSumbit = async () => {
        setLoading(true);

        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info') || '{}');
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            let response;
            let newContact = null;

            console.log("🚀 Selected Contacts before API call: ", selectedContacts);

            // 📌 Check if a new contact is being created
            if (!isEdit) {
                console.log("🔹 Creating new contact...");
                response = await axios.post(`${backendUrl}/api/contact`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,

                    },
                });

                newContact = response?.data?.contact;
                if (!newContact) throw new Error("Invalid response from server");

                // ✅ Add new contact to selected contacts list
                setSelectedContacts(prev => [
                    ...prev,
                    { label: newContact.name, value: newContact.id }
                ]);

                console.log("✅ New contact added to selection: ", newContact);

                // ✅ Add new contact to contacts list
                setContacts(prev => [...prev, newContact]);
            }

            // 📌 Ensure API gets called when selecting from dropdown
            if (projectId) {
                console.log("📢 Updating project contacts...");

                // Get selected contacts
                const selectedContactIds = selectedContacts.map(c => c.value);

                // Get existing project contacts
                const existingContactIds = (projectData?.contacts || []).map(c => c.id);

                // Add the newly created contact if applicable
                if (newContact) {
                    selectedContactIds.push(newContact.id);
                }

                // Merge all contacts (existing + selected)
                const updatedContacts = [
                    ...new Set([...existingContactIds, ...selectedContactIds])
                ].map(id => ({ id }));

                console.log("📌 Final contact list to update project: ", updatedContacts);

                // ✅ Call API to update project contacts
                const projectResponse = await axios.put(`${backendUrl}/api/projects/${projectId}`, {
                    name: projectData.name,
                    contacts: updatedContacts,
                }, {
                    headers: {
                        Authorization: ` Bearer ${token}`,
                        'Tenant-Origin': origin,

                    },
                });

                console.log("✅ Project update API called successfully!", projectResponse.data);

                // ✅ Update the project state with the new contacts
                setProjectDetails(prev => ({
                    ...prev,
                    contacts: projectResponse.data.Data.contacts,
                }));
            }

            setErrors({});
            setShowContactModal(false);
            setStatusModal(true);
        } catch (error) {
            console.error("❌ Error adding/updating contact: ", error);
            setErrors({ apiError: "Failed to save contact. Please try again." });
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const isSales = searchParams.get('sales') === 'true';

    return (

        <React.Fragment>
            {/* <h4 className="mb-sm-0 font-size-18">Quotations</h4> */}
            {!isSales && (

                <WithCreatePermission>
                    <button
                        type="button"
                        className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                        onClick={() => {
                            // Check if any quotation has a status equal to or beyond "Quotation Approved"
                            const invalidStatuses = [
                                'Quotation Approved',
                                'PO Received',
                                'Assign to Project Team',
                                'work completed',
                                'payment confirmed',
                                'payment collected',
                            ];

                            const hasInvalidStatus = quotations.some((quotation) =>
                                invalidStatuses.includes(quotation.quotation_status)
                            );

                            if (hasInvalidStatus) {

                                Swal.fire({
                                    toast: true,
                                    position: 'top-end', // You can change the position as needed
                                    icon: 'error',
                                    title: 'A quotation has already been approved!.',
                                    timer: 3000,
                                    timerProgressBar: false,
                                    showConfirmButton: false,
                                    didOpen: () => {
                                        const container = Swal.getContainer();
                                        container.style.top = '50px';
                                    }
                                });

                            } else {
                                // If no invalid status exists, proceed to open the modal
                                handleShowModal();
                            }
                        }} data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        id="tool"
                        title="Add Quotation"
                    >
                        <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                    </button></WithCreatePermission>
            )}<br /><br /><br /><br />


            <div className="contacts-table-modern">
                <div >
                    <table className="table table-modern">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Reference Number</th>
                                <th scope="col">Date</th>
                                <th scope="col">Total Amount</th>
                                <th scope="col">Status</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>

                            {quotations.length > 0 ? (
                                quotations.map((quotation, index) => {
                                    const project = projects.find(project => project.client_id === clientId);
                                    const nextStatus = getNextStatus(quotation.quotation_status); // Get the next status
                                    const dropdownMenuStyle = {
                                        display: 'block', // Ensure dropdown is visible
                                        position: 'absolute',
                                        top: '100%', // Position below button
                                        left: '0',
                                        backgroundColor: '#fff',
                                        border: '1px solid #ccc',
                                        zIndex: 1000,
                                    };

                                    const capitalizeWords = (str) => {
                                        return str.replace(/\b\w/g, (char) => char.toUpperCase());
                                    };
                                    const renderStatusDropdown = (quotation) => {
                                        const nextStatus = getNextStatus(quotation.quotation_status);
                                        const isVisible = dropdownVisible === quotation.id;

                                        // Check for "invalid" status
                                        if (quotation.quotation_status === 'invalid') {
                                            return <span>{capitalizeWords(quotation.quotation_status)}</span>; // Render plain text for "invalid"
                                        }

                                        // Render dropdown for other statuses
                                        return (
                                            <div className="dropdown" ref={(el) => (dropdownRefs.current[quotation.id] = el)}>
                                                <button
                                                    className="btn dropdown-toggle status-font"
                                                    type="button"
                                                    onClick={() => handleStatusClick(quotation.id)}
                                                >
                                                    {capitalizeWords(quotation.quotation_status)}
                                                </button>
                                                {isVisible && (
                                                    <ul className="dropdown-menu" style={dropdownMenuStyle}>
                                                        {nextStatus && (
                                                            <li>
                                                                <button
                                                                    className="dropdown-item status-font"
                                                                    onClick={() => handleDropdownSelect(quotation.id, nextStatus)}
                                                                >
                                                                    {capitalizeWords(nextStatus)}
                                                                </button>
                                                            </li>
                                                        )}

                                                    </ul>
                                                )}
                                            </div>
                                        );
                                    };
                                    return (
                                        <tr key={quotation.id}>
                                            <td>{index + 1}</td>
                                            <td onClick={() => handleShowDetailsModal(quotation.id)}>

                                                {quotation.ref_no}

                                            </td>
                                            {/* <td>
                                        <Link to={`/quotation/details/${quotation.id}`} className="dropdown-item">
                                            {quotation.project ? quotation?.project.client?.name : ""}
                                        </Link>
                                    </td> */}
                                            <td>{quotation.date}</td>
                                            <td>{displayConvertedAmount(quotation.amount, quotation.currency || clientCurrency || "AED")}</td>
                                            <td>{renderStatusDropdown(quotation)}</td>
                                            <td>
                                                <div className="dropdown">
                                                    <i
                                                        className="mdi mdi-dots-horizontal font-size-18"
                                                        data-bs-toggle="dropdown"
                                                        data-bs-boundary="viewport"
                                                        aria-expanded="false"
                                                        style={{ cursor: "pointer" }}
                                                    ></i>
                                                    <ul className="dropdown-menu dropdown-menu-end" style={{ zIndex: 10000 }}>
                                                        <li>
                                                            <WithviewPermission>
                                                                <Link to={`/quotation/details/${quotation.id}`} className="dropdown-item">
                                                                    View Details
                                                                </Link>
                                                            </WithviewPermission>
                                                        </li>
                                                        <li>
                                                            <WithPICPermission>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => handleGenerateProformaInvoice(quotation)}
                                                                >
                                                                    Generate Proforma Invoice
                                                                </button>
                                                            </WithPICPermission>
                                                        </li>
                                                        {quotation.proforma_invoices?.length > 0 && (
                                                            <li>
                                                                <WithPILPermission>
                                                                    <Link to={`/proformainvoice?quotation_id=${quotation.id}`} className="dropdown-item">
                                                                        Proforma Invoice List
                                                                    </Link>
                                                                </WithPILPermission>
                                                            </li>
                                                        )}
                                                        <li>
                                                            <WithPOCPermission>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => handleVendorDropdownChange(quotation)}
                                                                >
                                                                    Generate Vendor PO
                                                                </button>
                                                            </WithPOCPermission>
                                                        </li>
                                                        {quotation?.purchase_order && quotation?.purchase_order?.length > 0 && (
                                                            <li>
                                                                <WithPOLPermission>
                                                                    <Link to={`/purchase-order?quotation_id=${quotation.id}`} className="dropdown-item">
                                                                        Vendor PO Details
                                                                    </Link>
                                                                </WithPOLPermission>
                                                            </li>
                                                        )}
                                                        <li>
                                                            <WithEditPermission>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => handleShowModal(quotation.id)}
                                                                >
                                                                    Edit
                                                                </button>
                                                            </WithEditPermission>
                                                        </li>
                                                        <li>
                                                            <WithDeletePermission>
                                                                <button
                                                                    className="dropdown-item text-danger"
                                                                    onClick={() => deleteQuotation(quotation.id)}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </WithDeletePermission>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="7">No quotations available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {showStatusModal && !isQuoModalHidden && (

                <Offcanvas show={showStatusModal} onHide={() => setStatusModal(false)} placement="end" style={{ width: '440px' }}>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Change Quotation Status</Offcanvas.Title>
                    </Offcanvas.Header>
                    <hr style={{ margin: 0 }} /><br />

                    <Offcanvas.Body>
                        <div className='form-group mb-3'>
                            <label>Description:</label>
                            <textarea
                                name="description"
                                onChange={(e) => setDescription(e.target.value)}
                                className="form-control"
                            />
                        </div><br />
                        <div className='form-group mb-3'>
                            <label>Upload File:</label>
                            <input type="file" onChange={handleFileChange} className="form-control" />
                        </div><br />
                        {selectedStatus === "Assign To Project Team" && (
                            <div className='form-group mb-3'>
                                <label>Select Contacts</label>
                                {/* <Select
                                isMulti
                                options={contactOptions}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                value={selectedContacts}
                                onChange={setSelectedContacts}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        fontSize: '14px',
                                        borderRadius: '14px',
                                        height: '39px',
                                        border: '0.5px solid rgb(232, 233, 237)',
                                    }),
                                }}
                            /> */}
                                <CreatableSelect
                                    isMulti
                                    options={[
                                        { value: "create_new", label: <><FaPlus color="gray" /> Add new</> },
                                        ...contacts.map(contact => ({
                                            label: contact.name,
                                            value: contact.id,
                                        })),
                                    ]}

                                    value={selectedContacts}
                                    onChange={(selectedOption) => {
                                        console.log("📌 Selected Contact:", selectedOption);
                                        if (selectedOption.some(option => option.value === "create_new")) {
                                            // handleAddContactClick();
                                            // setIsQuoModalHidden(true);
                                            setShowContactModal(true);
                                            return; // Trigger modal if "Add Contact" is selected
                                        }
                                        setSelectedContacts(selectedOption);
                                    }
                                    }
                                    onCreateOption={handleSumbit}  // Handle creating new contact inside the dropdown
                                    placeholder="Select"
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />

                            </div>
                        )}
                    </Offcanvas.Body>
                    <div className="p-3 d-flex justify-content-end border-top">

                        <Button variant="primary me-2" onClick={handleStatusUpdate}>
                            Update
                        </Button>
                        <Button variant="secondary" onClick={() => setStatusModal(false)}>
                            Cancel
                        </Button>
                    </div>
                </Offcanvas>
            )}

            {/* {showVendorsModal && (
                <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Select Vendor for Purchase Order</h5>
                                <button type="button" className="btn-close" onClick={handleCloseVendorsModal}></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-4">

                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col">Vendor Name</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedQuotationProducts.length > 0 ? (
                                                selectedQuotationProducts.map((product, index) => {
                                                    const vendorName = vendorNames[product.product?.vendor_id];

                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                {vendorName ? (
                                                                    vendorName
                                                                ) : (
                                                                    <span className="text-muted">Vendor not found</span>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-primary btn-sm"
                                                                    onClick={() => handleCreatePurchaseOrder(product.product?.vendor_id)}
                                                                >
                                                                    Create Purchase Order
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="2" className="text-center text-muted">
                                                        No vendors available for this quotation.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={handleCloseVendorsModal}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )} */}

            {showVendorsModal && (
                <Offcanvas
                    show={showVendorsModal}
                    onHide={handleCloseVendorsModal}
                    placement="end"
                    backdrop="static"
                    style={{ width: '550px', borderLeft: '1px solid rgba(0,0,0,0.1)' }}
                >
                    {/* Header with gradient background */}
                    <Offcanvas.Header
                        closeButton
                        className="border-bottom pb-2"
                        style={{
                            background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)',
                            padding: '1.5rem 2rem'
                        }}
                    >
                        <div>
                            <Offcanvas.Title
                                as="h5"
                                style={{
                                    fontWeight: '600',
                                    fontSize: '1.4rem',
                                    color: '#2c3e50',
                                    marginBottom: '0.25rem'
                                }}
                            >
                                Vendor Selection
                            </Offcanvas.Title>
                            <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                                Select vendor to {selectedQuotationData?.purchase_order?.length ? 'view' : 'create'} purchase order
                            </p>
                        </div>
                    </Offcanvas.Header>

                    {/* Body with custom scrollbar */}
                    <Offcanvas.Body
                        className="px-0"
                        style={{
                            overflowY: 'auto',
                            scrollbarWidth: 'thin',
                            scrollbarColor: '#d1d8e0 #f1f3f5'
                        }}
                    >
                        <div className="px-4 pt-3 pb-2">
                            {/* <div className="alert alert-info py-2 mb-3" style={{ fontSize: '0.9rem' }}>
                                <i className="mdi mdi-information-outline me-2"></i>
                            </div> */}
                        </div>

                        {/* Vendor list with cards */}
                        <div className="px-4">
                            {selectedQuotationProducts.length > 0 ? (
                                <div className="vendor-list">
                                    {selectedQuotationProducts.map((product, index) => {
                                        const vendorName = vendorNames[product.product?.vendor_id];
                                        const vendorId = product.product?.vendor_id;
                                        const quotation = quotations.find(q => q.id === selectedQuotationId);
                                        const hasPO = quotation?.purchase_order?.some(po => po.vendor_id === vendorId);
                                        const existingPO = hasPO ? quotation.purchase_order.find(po => po.vendor_id === vendorId) : null;

                                        return (
                                            <div
                                                key={index}
                                                className="card mb-3 shadow-sm"
                                                style={{
                                                    borderLeft: hasPO ? '4px solid #4e73df' : '4px solid #f6c23e',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <div className="card-body py-3 px-4">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <h6 className="mb-1" style={{ fontWeight: '600' }}>
                                                                {vendorName || 'Unknown Vendor'}
                                                            </h6>
                                                            <small className="text-muted">
                                                                {product.product?.product_name || 'Product not specified'}
                                                            </small>
                                                            {existingPO && (
                                                                <div className="mt-1">
                                                                    <small className="text-primary">
                                                                        PO #: {existingPO.ref_no}
                                                                    </small>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div>
                                                            {hasPO ? (
                                                                <button
                                                                    className="btn btn-sm"
                                                                    onClick={() => {
                                                                        navigate(`/purchase-order/details/${existingPO.id}`);
                                                                        handleCloseVendorsModal();
                                                                    }}
                                                                    style={{
                                                                        background: '#4e73df',
                                                                        color: 'white',
                                                                        borderRadius: '6px',
                                                                        padding: '0.35rem 1rem',
                                                                        fontWeight: '500'
                                                                    }}
                                                                >
                                                                    <i className="mdi mdi-eye-outline me-1"></i> View PO Details
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className="btn btn-sm"
                                                                    onClick={() => handleCreatePurchaseOrder(vendorId)}
                                                                    style={{
                                                                        background: '#f6c23e',
                                                                        color: '#2c3e50',
                                                                        borderRadius: '6px',
                                                                        padding: '0.35rem 1rem',
                                                                        fontWeight: '500'
                                                                    }}
                                                                >
                                                                    <i className="mdi mdi-plus-circle-outline me-1"></i> Create PO
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="text-center py-5">
                                    <div className="mb-3" style={{ fontSize: '3rem', color: '#e9ecef' }}>
                                        <i className="mdi mdi-account-group-outline"></i>
                                    </div>
                                    <h5 className="text-muted mb-2">No Vendors Available</h5>
                                    <p className="text-muted" style={{ fontSize: '0.9rem' }}>
                                        This quotation doesn't have any products with assigned vendors.
                                    </p>
                                </div>
                            )}
                        </div>
                    </Offcanvas.Body>

                    {/* Footer with action buttons */}
                    <div
                        className="border-top px-4 py-3 d-flex justify-content-between align-items-center"
                        style={{ background: '#f8f9fa' }}
                    >
                        <div>
                            <span className="text-muted small">
                                Showing {selectedQuotationProducts.length} vendor{selectedQuotationProducts.length !== 1 ? 's' : ''}
                            </span>
                        </div>
                        <div>
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={handleCloseVendorsModal}
                                style={{
                                    borderRadius: '6px',
                                    padding: '0.35rem 1rem',
                                    fontWeight: '500'
                                }}
                            >
                                <i className="mdi mdi-close-circle-outline me-1"></i> Close
                            </button>
                        </div>
                    </div>
                </Offcanvas>
            )}

            <div className="d-flex justify-content-end pagination-sm">
                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageChange}
                    containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    previousClassName={'page-item previous'}
                    previousLinkClassName={'page-link'}
                    nextClassName={'page-item next'}
                    nextLinkClassName={'page-link'}
                    breakClassName={'page-item'}
                    breakLinkClassName={'page-link'}
                    activeClassName={'active'}
                />
            </div>
            {console.log('Rendering modal:', showPurchaseOrderModal)}


            {showPurchaseOrderModal && (
                <PurchaseOrderForm
                    showModal={showPurchaseOrderModal}
                    purchaseorderData={selectedPurchaseOrder}
                    poId={poId}
                    vendorId={selectedVendorId}
                    products={selectedQuotationProducts}
                    handleClose={handleClosePurchaseOrderModal}
                    projectId={projectId}
                    quotationId={selectedQuotationId}
                    // vendors={vendors}
                    vendors={Array.isArray(vendors) ? vendors : (vendors ? Object.values(vendors) : [])}
                    setPurchaseOrders={setPurchaseOrders}
                    isQuotationParent={true}
                    fetchQuotations={fetchQuotations}


                />

            )}
            {showProformaModal && (
                <ProformaInvoiceModal
                    showModal={showProformaModal}
                    quotationData={selectedQuotationData}
                    handleClose={handleCloseProformaModal}
                    quotationId={selectedQuotationId}
                    handleCreate={handleCreateProformaInvoice}
                    fetchDeals={fetchQuotations}


                />
            )}
            <QuotationDetailsModal
                quotationId={selectedQuotationId}
                projectId={projectId}
                deletePerformaInvoice={deletePerformaInvoice}
                showModal={showDetailsModal}
                handleCloseModal={handleCloseDetailsModal}
                products={selectedQuotationProducts}

            />

            {showContactModal && (
                <ContactModal
                    showModal={showContactModal}
                    handleClose={handleContactModalClose}
                    handleSubmit={handleSumbit}
                    formData={formData}
                    handleInputChange={handleInputChange}
                    errors={errors}
                    isEdit={isEdit}

                />
            )}
            {showUploadedQuotationEdit && (
                <QuotationUploadOffcanvas
                    show={showUploadedQuotationEdit}
                    handleClose={() => {
                        setShowUploadedQuotationEdit(false);
                        setSelectedUploadedQuotation(null);
                    }}
                    deal={null}
                    quotationData={selectedUploadedQuotation}
                    onSuccess={async () => {
                        setShowUploadedQuotationEdit(false);
                        setSelectedUploadedQuotation(null);
                        if (typeof fetchQuotations === 'function') {
                            await fetchQuotations();
                        }
                    }}
                />
            )}
            <QuotationForm
                showModal={showModal}
                handleClose={handleCloseModal}
                quotationId={selectedQuotationId}
                quotationData={selectedQuotationData}
                addQuotation={addQuotation}
                editQuotation={editQuotation}
                projects={projects}
                errors={errors}
                setErrors={setErrors}
                projectId={projectId}
                defaultClientId={clientId}
                fetchProjects={fetchProjects}
                refNo={refNo}
                products={products}
                setProducts={setProducts}
                // fetchProducts={fetchProducts}
                projectName={projectName}
                clientName={clientName}
                clientCurrency={clientCurrency}
            />

        </React.Fragment>


    );
};

export default QuotationList;







